import React from 'react';
import { Box, Text, Flex, IconButton, Tooltip } from '@chakra-ui/react';
import { FaSyncAlt } from 'react-icons/fa';

const DeliverySummary = ({ userName, total, completed, onRefresh, isRefreshing = false }) => {
  return (
    <Box p={4} bg="white" borderBottomWidth="1px" borderBottomColor="gray.200">
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontSize="md">
          {userName}님의 금일 배송 건 수 ({completed}/{total})
        </Text>

        <Tooltip label="새로고침" hasArrow placement="bottom">
          <IconButton
            icon={<FaSyncAlt />}
            aria-label="새로고침"
            size="md"
            variant="ghost"
            onClick={onRefresh}
            isLoading={isRefreshing}
            isDisabled={isRefreshing}
            minW="auto"
            h="auto"
            p={1}
          />
        </Tooltip>
      </Flex>
    </Box>
  );
};

export default DeliverySummary;